import prismatic from "@/game-tft/PrismaticHexIcon.jsx";
import bronze from "@/inline-assets/tft-hex-bronze.svg";
import gold from "@/inline-assets/tft-hex-gold.svg";
import silver from "@/inline-assets/tft-hex-silver.svg";

export default {
  prismatic,
  gold,
  silver,
  bronze,
};
